import React from "react";
import {
  InstagramLogoIcon,
  WhatsappLogoIcon,
  FlaskIcon,
  InfoIcon,
  PhoneIcon,
} from "@phosphor-icons/react";
import { Link } from "react-router-dom";

export default function HeadRibbon() {
  return (
    <div className="h-fit items-end justify-between bg-green-600 text-white  px-10 py-2 font-traffic md:grid md:grid-flow-col md:grid-cols-11">
      <a
        className="grid grid-flow-col text-base justify-around md:col-span-2 md:justify-start items-end mr-5"
        title="تماس با پشتیبانی نرم‌افزار"
        href="tel:02155439270"
      >
        <p className="pl-2 text-sm whitespace-nowrap">با ما تماس بگیرید: </p>
        <p className=" text-sm whitespace-nowrap"> 021-55439270 </p>
      </a>
      <div className="col-span-6"></div>
      {/* برای اضافه کردن تلگرام و اینستاگرام grid-flow-col grid-cols-3 */}
      <Link
        className="text-sm hidden justify-center items-center gap-1 md:flex whitespace-nowrap"
        to="./contact_us"
      >
        <PhoneIcon
          weight="fill"
          title="تماس با آزمایاران"
          className="shrink-0"
        />
        تماس با ما
      </Link>
      <Link
        className="text-sm hidden md:flex justify-center items-center gap-1 whitespace-nowrap"
        to="./about_us"
        title="درباره آزمایاران"
      >
        <InfoIcon weight="fill" className="shrink-0" />
        درباره‌ ما
      </Link>

      <a
        className="text-sm hidden md:flex justify-center items-center gap-1 whitespace-nowrap"
        href="https://blog.azmayaran.com/"
        target="_blank"
        title="مجله آزمایاران"
      >
        <FlaskIcon weight="fill" className="shrink-0" />
        وبلاگ
      </a>
      {/* <Link
        className="text-sm hidden md:flex justify-center items-center gap-1"
        to="./"
      >
        <SealQuestion weight="fill" />
        راهنمای ورود
      </Link> */}

      <div className="hidden  justify-end items-center gap-3  md:flex ">
        <a
          href="https://www.instagram.com/azmayaran"
          title="صفحه اینستاگرام آزمایاران"
        >
          <InstagramLogoIcon size="6mm" />
        </a>
        <a
          title="با حساب واتس‌اپ آزمایاران در ارتباط باشید"
          target="_blank"
          href="https://wa.me/09124608709"
        >
          <WhatsappLogoIcon size="6mm" />
        </a>
        {/* <a title="با حساب تلگرام آزمایاران در ارتباط باشید" href="#">
                    <TelegramLogo size="6mm" color="#1b2a37" />
                </a> */}
      </div>
      {/* <div className="flex-grow"></div> */}
    </div>
  );
}
